import { Flex, Typography } from "antd";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";

import { CommonTable } from "components";
import { useStores } from "stores";
import { getColumns } from "./getColumns";

export const UsersPage = observer(() => {
  const { userList } = useStores();
  const navigate = useNavigate();

  return (
    <Flex vertical gap="large">
      <Typography.Title className="margin-none">Пользователи</Typography.Title>
      <CommonTable
        store={userList}
        columns={getColumns(userList)}
        onRow={(record) => ({
          onClick: () => {
            navigate(record.id);
          },
          className: "cursor-pointer",
        })}
        whiteBox
        widgets={{
          search: true,
          date: true,
        }}
      />
    </Flex>
  );
});
